// @flow
import React from "react";
import DisabledAccess from "../../../svg/facilities/has_disabled_access.svg";
import "./disabledAccessIcon.scss";

const DisabledAccessIcon = () => (
  <DisabledAccess className="c-disabled-access-icon" />
);

export default DisabledAccessIcon;
